import { DEFAULT_LANGUAGE } from 'constants/localization';

import BrowserStorage from './browserStorage';

export const getLanguage = (): string => BrowserStorage.getItem('language') || DEFAULT_LANGUAGE;

export const setLanguage = (language: string) => BrowserStorage.setItem('language', language);
